import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* addBreakoutRoomSaga() {
  yield call(SignalingSocket.send, {
    event: 'addBreakoutRoom',
  });
}
